import React from 'react';

import NakedNewsLogoWhite from '../../assets/Affiliate/Logos Icons/NN-logo.png';


function MembershipHeader(props) {
  const { isMembershipPaymentPage, mrSkinCampaign, fanzoneCampaign } = props;

  if (mrSkinCampaign) {
    return <img alt="nakedNEWS" src={NakedNewsLogoWhite} />;
  }

  if (!isMembershipPaymentPage || fanzoneCampaign) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="membership-header flex items-center justify-center">
        <h1>
          SUBSCRIBE TO
        </h1>
        <img alt="nakedNEWS" src={NakedNewsLogoWhite} />
      </div>
      <div className="membership-benefits flex flex-col">
        <h3>MEMBERSHIP INCLUDES:</h3>
        <ul className="list-italic">
          <li>6 New Programs a week</li>
          <li>Gorgeous cast of fully naked anchors</li>
          <li>Amateur Auditions</li>
          <li>1000&apos;s of hours of show archives</li>
          <li>Full Screen-HD Video</li>
        </ul>
      </div>
    </React.Fragment>
  );
}

export default MembershipHeader;
